import type { HTMLAttributes, ReactNode } from 'react'
import * as stylex from '@stylexjs/stylex'

type CardVariant = 'default' | 'subtle' | 'highlight'
type CardPadding = 'none' | 'sm' | 'md' | 'lg'

type CardProps = HTMLAttributes<HTMLElement> & {
  as?: 'article' | 'section' | 'div'
  children: ReactNode
  padding?: CardPadding
  variant?: CardVariant
}

const styles = stylex.create({
  root: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#e1e8df',
    borderRadius: '1rem',
    backgroundColor: '#fff',
    boxShadow: '0 1px 2px rgb(38 59 42 / 3%)',
  },
  subtle: { borderColor: '#d9e8d7', backgroundColor: '#f7fbf6' },
  highlight: { borderColor: '#72a77d', backgroundColor: '#4c9560', color: '#fff' },
  none: { padding: 0 },
  sm: { padding: '14px' },
  md: { padding: '16px' },
  lg: { padding: '24px' },
})

export default function Card({ as: Tag = 'section', children, className = '', padding = 'md', style, variant = 'default', ...props }: CardProps) {
  const cardProps = stylex.props(styles.root, variant !== 'default' && styles[variant], styles[padding])
  return <Tag {...props} className={`${cardProps.className} ${className}`.trim()} style={{ ...cardProps.style, ...style }}>{children}</Tag>
}
